module.exports = __webpack_public_path__ + "assets/img/bg.a560d4ea.webp";